import {
  LocationQuestionConfig,
  LocationResponseState,
} from '@gripp/shared-logic';
import { StyleSheet, View } from 'react-native';
import openMap from 'react-native-open-maps';
import { Text } from 'react-native-paper';
import { Colors } from '../../../../../themes/colors';
import { Link } from '../../../../crop-circle/Link';
import {
  ArrowTopRightAngleIcon,
  LocationIcon,
} from '../../../../crop-circle/icons';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const LocationQuestionMessage: RoutineQuestionMessage<
  LocationQuestionConfig,
  LocationResponseState
> = (
  props: RoutineQuestionMessageProps<
    LocationQuestionConfig,
    LocationResponseState
  >
) => {
  const { response } = props;
  const memo = response?.memo;

  if (!response?.value && !memo) {
    return <Text style={props.textStyle}>—</Text>;
  }

  const handlePress = () => {
    const coordinates = response?.coordinates;
    if (coordinates) {
      const [longitude, latitude] = coordinates;
      openMap({ query: `${latitude}, ${longitude}` });
    } else if (response?.value) {
      openMap({ query: response.value });
    }
  };

  return (
    <View style={styles.container}>
      {response?.value ? (
        <Link
          children={response.value}
          underline={false}
          rightIcon={<ArrowTopRightAngleIcon size={12} />}
          leftIcon={<LocationIcon size={12} />}
          onPress={handlePress}
          emphasised={false}
          color="neutral"
          textStyle={{ fontWeight: '500' as const }}
          wrap
        />
      ) : null}
      {memo ? <Text style={[props.textStyle, styles.memo]}>{memo}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: 4,
  },
  memo: {
    color: Colors.role.textSecondary,
    fontStyle: 'italic',
  },
});
